import { bl_fi_my_einvoice_tax_type_code_RowClass } from '../../dbschema';
import { BaseContainerModel } from '../base-container.model';

export class MyEInvoiceTaxTypeCodeContainerModel extends BaseContainerModel {
    bl_fi_my_einvoice_tax_type_code: bl_fi_my_einvoice_tax_type_code_RowClass = new bl_fi_my_einvoice_tax_type_code_RowClass();
}
